import { Locale, type LocalizedString } from "../Locale.js";

export const helpPagePathMap = {
	[Locale.cs]: "jak-vam-muzeme-pomoci" as const,
} satisfies LocalizedString;
